export const TreatmentPlanRow = {
  flow: 'x',
  align: 'center space-between',
  padding: 'Z A',
  borderBottom: '1px solid inkBorder',
  gap: 'A',
  ToothBadge: { text: (el, s) => '#' + s.tooth, fontSize: 'Z', fontWeight: '700', color: 'teal', width: 'B', textAlign: 'center' },
  ProcedureName: { text: (el, s) => s.procedure, fontSize: 'Z', color: 'inkText', fontWeight: '500', flex: '1' },
  PlanStatus: { extends: 'StatusBadge' },
  PlanPrice: { text: (el, s) => s.price, fontSize: 'Z', color: 'teal', fontWeight: '600', width: 'C', textAlign: 'right' },
  PlanDoctor: { text: (el, s) => s.doctor, fontSize: 'Y', color: 'inkMuted', width: 'E' }
}
